export const getCookie = (name: string): string => document.cookie.split(';')
  .map((cookie) => cookie.split('='))
  .filter((tokens) => tokens[0].trim() === name)
  .map((tokens) => tokens[1])
  .shift() || ''
